import React, { Component } from 'react'
import { observable, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import CKeditor5 from '../CKeditor5'
import Button from '../../UniformComponents/Button'
import Panel from '../../UniformComponents/Panel'
import Input from '../form/Input'

@observer
class Priority extends Component {
    render() {
        const { page } = this.props
        return (
            <span className="bold">
                {i18n.t('s_page')}
                :
                {' '}
                {page.priority}
            </span>
        )
    }
}

@observer
class QuotaFullPage extends Component {
    @observable saveState = ''

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    savePage = () => {
        const that = this
        const { page, store } = this.props
        const { survey } = store
        if (store.survey.closed) {
            return
        }
        const langCode = store.surveyLocale
        console.log('savePage')
        const content = {
            locale: langCode,
            text: page.content.get(langCode).text,
            redirectUrlSettings: page.redirectUrlSettings,
        }
        store.http.put(`/api/survey/${survey.id}/page/${page.id}/content`, JSON.stringify(content), store.surveyToken)
            .then((response) => {
                const state = response.match(/updated/) ? 'saved' : 'failed'
                if (state === 'saved') {
                    store.addNotification(null, 'Quota full page saved', 'success')
                } else {
                    store.addNotification(null, 'Error saving quota full page', 'error')
                }
                that.saveState = state
            })
            .catch((e) => {
                console.log(e)
                store.addNotification(null, e.message, 'error')
                that.saveState = 'failed'
            })
    }

    updateRedirectUrlChecked = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        page.redirectUrlChecked = !e.redirectUrlChecked
        page.update()
    }

    handleEditorChange = (value) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        const lang_code = store.surveyLocale
        page.content.get(lang_code).text = value
    }

    removePage = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        // store.survey.removePage(page_id)
        store.pageToDeleteId = page.id
        store.pageToDeleteType = 'QF'
        store.pageDeleteConfirm = true
        e.preventDefault()
    }

    updateTitle = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        page.title = e.target.value
        page.update()
    }

    getContent = () => {
        const { page, store } = this.props
        const { survey } = store
        const langCode = store.surveyLocale
        if (!page.content.has(langCode)) {
            const text = page.content.has(survey.metadata.defaultLocale) ? page.content.get(survey.metadata.defaultLocale).text : ''
            page.content.set(langCode, {
                text,
            })
        }
        return page.content.get(langCode).text
    }

    previewPage = () => {
        const { page, store } = this.props
        let link = store.survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)
        link += `&pageId=${page.id}`
        store.gotoExternal(link)
    }

    dataViewerLink = () => {
        const { page } = this.props
        return (
            <a className="redlink" target="_blank" href={`/intranet/dataviewer?schema=explori_v3&tablename=survey_page_question&f1=surveyPageId&op1=eq&val1=${page.id}&viewdata=true`} rel="noreferrer">
                {page.id}
            </a>
        )
    }

    updateRedirectUrl = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        page.redirectUrlSettings.redirectUrl = e.target.value.trim()
    }

    updateDelayMs = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        page.redirectUrlSettings.delayRedirectSec = parseInt(e.target.value, 10)
    }

    updateRedirectUrlChecked = (e) => {
        const { page, store } = this.props
        if (store.survey.closed) {
            return
        }
        page.redirectUrlChecked = !page.redirectUrlChecked
        if (!page.redirectUrlChecked) {
            page.redirectUrlSettings.delayRedirectSec = 2
            page.redirectUrlSettings.redirectUrl = ''
        }
    }

    render() {
        const { page_id, page, store } = this.props
        const { survey } = store
        const label = page.title
        const key = `${page_id}tinymce`
        const content = this.getContent()
        const redirectUrlChecked = page.redirectUrlSettings.redirectUrl === ''
        return (
            <Panel>
                <div>
                    <Priority page={page} />
                    <Input type="text" disabled={survey.closed} defaultValue={label} onChange={this.updateTitle} />
                    {store.showIds
                        && <span style={{ 'margin-left': '5px' }}>{this.dataViewerLink()}</span>}
                    <label style={{ marginLeft: '15px' }}>
                        <input type="checkbox" checked={page.redirectUrlChecked} onChange={this.updateRedirectUrlChecked} />
                        <label style={{ marginLeft: '10px' }}>Add URL Redirect</label>
                    </label>
                    {page.redirectUrlChecked
                        && (
                            <div style={{ display: 'flex', marginTop: '10px', marginBottom: '10px' }}>
                                <div>
                                    <span className="bold">{i18n.t('s_enter_url_text')}</span>
                                    <input type="text" style={{ width: '300px' }} className="form-control" defaultValue={page.redirectUrlSettings.redirectUrl} onChange={this.updateRedirectUrl} />
                                </div>
                                <div style={{ marginLeft: '10px' }}>
                                    <span className="bold">{i18n.t('s_delay_seconds')}</span>
                                    <input
                                        type="number"
                                        style={{
                                            width: '80px',
                                            marginLeft: '10px',
                                            display: 'inline-block',
                                        }}
                                        defaultValue={page.redirectUrlSettings.delayRedirectSec}
                                        min={0}
                                        step={1}
                                        onChange={this.updateDelayMs}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        )}
                    <span className="options">
                        <i className="fal fa-play browse browse" onClick={this.previewPage} title={i18n.t('s_alt_previewpage')} />
                        <i className="fal fa-times-circle deleteicon deletesurveypage right" onClick={this.removePage} title={i18n.t('s_alt_delpage')} />
                    </span>
                    <div className="padding bold">{i18n.t('s_quotaFullText')}</div>
                    <CKeditor5
                        activeClass="p10"
                        toolbar="surveyExit"
                        key={key}
                        data={content}
                        onChange={this.handleEditorChange}
                        config={{
                            mergeFields: store.mergeFields,
                        }}
                    />
                </div>
                <Button cssClass="add_page internal pageSave pull-right" onClick={this.savePage}>{i18n.t('save')}</Button>
                <div className="saveState">
                    {this.saveState === 'saved'
                        && <i className="fa fa-check saved"> Saved</i>}
                    {this.saveState === 'failed'
                        && <i className="fa fa-ban saveFailed"> Save failed</i>}
                </div>
                <div style={{ clear: 'both' }} />
            </Panel>
        )
    }
}

export default QuotaFullPage
